import React, { useState } from "react";
import { Modal, Button, Box, Typography } from "@mui/material";
import Grid from "@material-ui/core/Grid";
import { labels } from "_utils/labels";
import Link from "@material-ui/core/Link";
import { logo } from "images";
import { CustomComments } from "_components";

const PartialApprovalModal = ({ open, onConfirm, handleClose, action }) => {
  const [comments, setComments] = useState("");
  const forVerify = action === "PARTIALVERIFY"

  const handleCommentsChange = (value) => {
    setComments(value);
  };

  const handleConfirm = () => {
    onConfirm(comments);
  };

  return (
    <Modal
      open={open}
      aria-labelledby="child-modal-title"
      aria-describedby="child-modal-description"
    >
      <Box className="modalpopup inputtags RejectioninputModal ">
        <Box className="row modalpopupinner">
          <Grid item xs={12} className="forgotpassword p-0">
            <Link href="#" variant="logo" className="wgllogo">
              <img src={logo} alt="logo"></img>
              {labels.eServicePortal}
            </Link>
            <Typography component="h2" variant="body1">
              Partial {forVerify? "Verify" : "Approval"} Comments
            </Typography>
          </Grid>
          <Box className="p-0">
            <CustomComments
              label="Comments"
              maxLength={1000}
              value={comments}
              onChange={(e) => handleCommentsChange(e.target.value)}
            />

            <Box className="Filtercontainerinner">
              <Typography component="div" className="CreateMarketerbutton">
                <Button
                  type="submit"
                  variant="contained"
                  className="submitbutton"
                  color="primary"
                  onClick={handleConfirm}
                  disabled={comments.trim() === ""}
                >
                  Confirm
                </Button>
                <Button
                  variant="contained"
                  color="red"
                  className="cancelbutton"
                  onClick={handleClose}
                >
                  Cancel
                </Button>
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default PartialApprovalModal;
